import { Component, OnInit, AfterViewInit } from '@angular/core';
import { clickableColumns } from 'src/app/middleware/common/clickableColumns';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { CommonService } from 'src/app/middleware/common/common.service';
import { Constants } from 'src/app/middleware/common/reusableclassesAndFunctions/constants';
import { MatDialog } from '@angular/material/dialog';
import { ExcelServicesService } from 'src/app/middleware/common/excel-services.service';
import { downloadableListAsDisplayedColumns } from 'src/app/middleware/common/table/table.component';
import { Observable, Subscription } from 'rxjs';
import { ConfirmDialogModel, ConfirmDialogComponent } from 'src/app/middleware/common/reusableComponents/confirm-dialog/confirm-dialog.component';
import { PaginationViewModel } from 'src/app/viewModels/permissions/paginationViewModel/pagination-view-model';
import { DeleteModuleMasterVM } from 'src/app/viewModels/moduleMaster/delete-module-master-vm';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import { PageEvent } from '@angular/material/paginator';
import { DataSharingService } from 'src/app/middleware/common/resuableServices/data-sharing.service';
import { ModuleMasterService } from '../services/moduleMaster/module-master.service';

@Component({
  selector: 'app-module-lists',
  templateUrl: './module-lists.component.html',
  styleUrls: ['./module-lists.component.scss']
})
export class ModuleListsComponent implements OnInit,AfterViewInit {
  showBadge : number = 3;
  OfficeIDList: any=[];
  
  constructor(private paginationVM: PaginationViewModel, private reusableClass: ReusableClasses,
    private statusConst: StatusConstant, private loaderService: LoaderService,
    private toastr: ToastrService, private router: Router,
    private commonService: CommonService, private excelService: ExcelServicesService, 
    private constant: Constants, private deleteVM: DeleteModuleMasterVM, 
    private dialog: MatDialog, private moduleService: ModuleMasterService,
    private _dataSharingService: DataSharingService) { 
      var offices=JSON.parse(sessionStorage.getItem('officeList'));
      offices.forEach(oe => {
      this.OfficeIDList.push(oe.officeID)
      });
    // this.permissions = JSON.parse(sessionStorage.getItem("permissions"));
    // this.permissions.forEach(element => {
    //   this.constant.routeArray.forEach(route => {
    //     if (element.moduleRoute == route.moduleMatserRoute) {
    //       if (element.isAddPermission == true) {
    //         this.showAdd = true;
    //       }
    //       if (element.isDeletePermission == true) {
    //         this.showDelete = true;
    //       }
    //       if (element.isEditPermission == true) {
    //         this.showEdit = true;
    //       }
    //     }
    //   });
    // })

    if (this.showEdit == true && this.showDelete == true) {
      this.sendDisplayedColumns = ['moduleName', 'moduleRoute', 'isActive',  'Edit', 'Delete'];
      this.showColumnNames = ['Module Name', 'Module Route', 'Status', 'Edit', 'Delete'];
      this.clickableColumns = [{ column: 'Edit', icon: 'edit', function: 'openEditDialog' }, {
        column: 'Delete', icon: 'delete', function: 'deleteUserDialog'
      }];
    }
    else if (this.showEdit == true && this.showDelete == false) {
      this.sendDisplayedColumns = ['moduleName', 'moduleRoute', 'isActive', 'Edit'];  // this is being used in child component $$...		
      this.showColumnNames = ['Module Name', 'Module Route', 'Status', 'Edit'];  // this is being used if child component will show lable with different names $$...		
      this.clickableColumns = [{ column: 'Edit', icon: 'edit', function: 'openEditDialog' }];
    }
    else if (this.showEdit == false && this.showDelete == true) {
      this.sendDisplayedColumns = ['moduleName', 'moduleRoute', 'isActive', 'Delete'];
      this.showColumnNames = ['Module Name', 'Module Route', 'Status', 'Delete'];
      this.clickableColumns = [{ column: 'Delete', icon: 'delete', function: 'deleteUserDialog' }];
    }
    else {
      this.sendDisplayedColumns = ['moduleName', 'moduleRoute', 'isActive'];  // this is being used in child component $$...		
      this.showColumnNames = ['Module Name', 'Module Route', 'Status'];  // this is being used if child component will show lable with different names $$...		
      this.clickableColumns = [];
    }

  }

 
  //currentData: any;
  showEdit: boolean = true;
  showAdd: boolean = true;
  showDelete: boolean = true;
  targetList: any = [];
  sendDisplayedColumns: string[] = [];
  showColumnNames: string[] = [];
  clickableColumns: clickableColumns[] = [];
  permissions: any[] = [];
  showcreateForm: Boolean = false;
  showSidePanel: boolean = false;
  showeditForm: boolean = false;
  totalCount: number;
  pageModelData = {
    pageIndex: 0,
    pageSize: 10,
    SearchKey:"",
    OfficeIDList:[]
  };
  isEdit = false;
  deleteModuleResponseHolder: any;
  moduleList: any[] =[];
 
  pageIndex: any;
  pageSize: any;
  value = '';
  paginatorTotalLength: any;
  currentData: PageEvent;
  Module:string;
  SearchValueForModuleSubscription: Subscription;
  
  ngOnDestroy(): void {
    this.SearchValueForModuleSubscription.unsubscribe();    
 }
 
  ngOnInit(): void {
    this.Module="Module";
    this.SearchValueForModuleSubscription = this._dataSharingService.getSearchValueForModule().subscribe((result) => {
        this.Search(result);       
      });
        
  }

  ngAfterViewInit(){
    setTimeout(() => {
      this.getModuleList(this.pageModelData);
    }, 1);
  }

    getModuleList(pageData: any) {      
     this.loaderService.show();    
     this.pageModelData.pageIndex = pageData.pageIndex;
     this.pageModelData.pageSize = pageData.pageSize;
     this.pageModelData.SearchKey = pageData.SearchKey.trim();
     this.pageModelData.OfficeIDList=this.OfficeIDList;   
     this.pageIndex = pageData.pageIndex;
     this.pageSize = pageData.pageSize;
     this.moduleService.getModuleList(this.pageModelData).subscribe(response => {
       if (response != undefined) {
        this.deleteModuleResponseHolder = response;
        if (this.deleteModuleResponseHolder.status == this.statusConst.statusSuccess) {
          this.deleteModuleResponseHolder.data.moduleModel.map(res => {
            res.isActive = res.isActive === true ? 'Active' : 'In-Active';
            return res;
            });
          this.moduleList = this.deleteModuleResponseHolder.data.moduleModel;
          this.totalCount = this.deleteModuleResponseHolder.data.totalCount;//this.moduleList[0].totalCount;

         // this.paginatorTotalLength = this.deleteModuleResponseHolder.data.totalRecords;
          this.pageModelData.pageIndex = this.deleteModuleResponseHolder.data.pageIndex;
          this.pageIndex = this.deleteModuleResponseHolder.data.pageIndex;
          this.pageSize = pageData.pageSize;
          this.loaderService.hide();          
        }
      }
    });
  }

  CallNextPrevPageData(pageData: PageEvent) {
    // this.currentData = pageData;
    // this.pageModelData.pageIndex = pageData.pageIndex;
    // this.pageModelData.pageSize = pageData.pageSize;
    // this.paginationVM.pageIndex = pageData.pageIndex;
    // this.paginationVM.pageSize = pageData.pageSize;
    // this.getModuleList(this.pageModelData);
    this.currentData = pageData;
    this.pageModelData.pageIndex = pageData.pageIndex;
    this.pageModelData.pageSize = pageData.pageSize;
    this.pageModelData.SearchKey = this.value.trim();
    this.getModuleList(this.pageModelData);
  }

  exportAsXLSX(): void {
    this.pageModelData.pageIndex = 0;
    let pagesize = this.pageModelData.pageSize;
    this.pageModelData.pageSize = this.totalCount;
    this.paginationVM.pageIndex = this.pageModelData.pageIndex;
    this.paginationVM.pageSize = this.pageModelData.pageSize;
    this.loaderService.show();
    this.moduleService.getModuleList(this.paginationVM).subscribe(response => {
      if (response != undefined) {       
        this.deleteModuleResponseHolder = response;
        this.deleteModuleResponseHolder.data.moduleModel.map(res => {
          res.isActive = res.isActive === true ? 'Active' : 'In-Active';
          return res;
          });
        let _moduleList = this.deleteModuleResponseHolder.data.moduleModel;
        let exportList: any[] = downloadableListAsDisplayedColumns(_moduleList, this.sendDisplayedColumns, this.clickableColumns, this.showColumnNames);
        this.excelService.exportAsExcelFile(exportList, 'ModuleList');
      }

    });
    this.loaderService.hide();
    this.pageModelData.pageSize = pagesize;
  }

  openEditDialogData(values) {
    let userData = values.data;
    if (values.function == "openEditDialog") {
      this.openEditDialog(true, userData);
    }
    else {
      this.deleteUserDialog(values.data);
    }
  }

  openEditDialog(editable: boolean, permission: any) {
    this.isEdit = editable;
    let dataarr = [];
    dataarr.push(this.isEdit);
    dataarr.push(permission);
    this.commonService.setEditData(dataarr);
    this.showcreateForm = false;
    this.showeditForm = true;
    this.showSidePanel = true;
  }

  deleteUserDialog(data): void {
    const message = `Are you sure you want to delete this module?`;    
    this.deleteVM.moduleID = data.moduleID;
    const title = `Confirm Delete`;
    const confirm = `Delete`;
    const dialogData = new ConfirmDialogModel(title, message,confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData
    });

    dialogRef.beforeClosed().subscribe(async dialogResult => {
      try {
        if (dialogResult) {
          this.loaderService.show();
          const result = await this.moduleService.deleteModule(this.deleteVM).toPromise();
          this.deleteModuleResponseHolder = result;
          this.loaderService.hide();
          this.toastr.success("Deleted successfully.", '', {
            timeOut: 3000,
          });
          let count = (Number(this.paginationVM.pageIndex) * Number(this.paginationVM.pageSize))
          if(this.totalCount - 1 == count){
            this.paginationVM.pageIndex =this.paginationVM.pageIndex - 1;
          }
          this.getModuleList(this.pageModelData);
          return result;
        } else {
          this.loaderService.hide();         
        }
      } catch (e) {
        Observable.throw(e);
      }
    });
  }

  closeSidePanel(event) {
    this.showSidePanel = false;
    this.showeditForm = false;
    this.showcreateForm = false;
    if (event == true) {
      this.getModuleList(this.pageModelData);
    }
  }

  addModule() {
    this.showcreateForm = true;
    this.showSidePanel = true;
    this.showeditForm = false;
  }

  Search(filterValue) {
    this.pageModelData.SearchKey = filterValue.trim();
    this.pageModelData.pageIndex = 0;
    this.pageModelData.pageSize = 10;
    this.getModuleList(this.pageModelData);
  }

 
}
